<template>
  <div>
    <template v-for="(a, index) in col.actions">
      <b-button
        v-if="a.show === undefined || $resolveFn(a.show, { row, col })"
        :disabled="a.disabled !== undefined && $resolveFn(a.disabled, { row, col })"
        :key="index"
        size="sm"
        :variant="a.variant"
        @click.prevent="handleClick(a)">
        <i v-if="a.icon" class="fa fa-fw" :class="'fa-' + a.icon"></i>
        <span v-if="isMdUp">
          {{ $resolveFn(a.label, { row, col }) }}
        </span>
      </b-button>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    row: {},
    col: {},
    r: {},
    c: {},
  },

  methods: {
    handleClick(a) {
      a.action({
        row: this.row,
        col: this.col,
        r: this.r,
        c: this.c,
      });
    }
  }
}
</script>
